import { useQuery } from '@tanstack/react-query'
import { useCustomerId } from 'features/customers/hooks/useCustomerId'

import { get } from 'utils/http'

export const useCustomerFeatures = (initialData = true, specificCustomerId?: any) => {
  const urlParamsCustomerId = useCustomerId()
  const customerId = specificCustomerId || urlParamsCustomerId

  return useQuery({
    queryKey: ['customer', customerId, 'features'],
    queryFn: () => get(`/management/customers/${customerId}/features?`),
    initialData: initialData ? {} : undefined,
  })
}
